import classNames from 'classnames';
import { observer } from 'mobx-react';
import { LOCALES } from '~/constants/main';
import { localeStore } from '~/mobx/localesStore';
import './style.scss';

type CampaignContentProps = {
  text: string;
  language: string;
  placeholder: string;
  hint: string;
  isValid: boolean;
  maxChars: number;
  className?: string;
  onChange: (event: React.ChangeEvent<HTMLTextAreaElement>) => void;
};

const CampaignContent = observer(({ text, language, placeholder, hint, isValid, maxChars, className, onChange }: CampaignContentProps) => (
  <>
    <textarea
      className={classNames(
        'message-campaign-area__input input full-width px-4 py-3',
        language === LOCALES.EN ? 'text-start' : 'text-end',
        { ['border-red']: !isValid },
        className
      )}
      placeholder={placeholder}
      maxLength={maxChars}
      onChange={onChange}
      value={text}
    />

    <p
      className={`message-campaign-area__placeholder family-medium color-gray2 text-size-12 ${
        language === LOCALES.EN ? 'message-campaign-area__placeholder_start' : 'message-campaign-area__placeholder_end'
      }`}
    >
      {localeStore.t(hint)}
    </p>
  </>
));

export default CampaignContent;
